<template>
    <div>
        <template v-if="!newVersion">
            <md-field :class="fieldClass">
                <label>
                    {{ label || $t('registration.entity-country') }}
                </label>

                <md-select v-model="country_id" :name="name" :disabled="disabled" @md-selected="selected" dusk="country-input">
                    <md-option v-for="country in countries" :key="country.id" :value="country.id">
                        {{ country.nom[$i18n.locale()] }}
                    </md-option>
                </md-select>

                <span class="md-error">
                    {{ errors && errors.length ? errors[0] : '' }}
                </span>
            </md-field>
        </template>
        <template v-else>
            <label class="block ml-1 mb-1 text-xs font-medium !text-primary-dark-50">
                {{ label || $t('registration.entity-country') }}
            </label>
            <md-menu :class="fieldClass" md-direction="bottom-start" class="block bg-white border border-gray-200 !text-primary-dark-50 text-sm rounded-md focus:ring-blue-900 block w-full p-1.5 placeholder:italic">
                <md-button md-menu-trigger class="country-selector !py-0 !min-w-8 !px-0 nv-button text-sm font-normal h-auto w-full normal-case !text-primary-dark-50">
                    <span class="flex items-center justify-between w-full">
                        <span>{{ currentLabel || $t('registration.select-entity-country') }}</span>
                        <svg class="w-4 h-4 ml-2 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                        </svg>
                    </span>
                </md-button>
                <md-menu-content>
                    <md-menu-item
                        v-for="country in countries"
                        :key="country.id"
                        @click="choose(country)"
                    >
                        {{ country.nom[$i18n.locale()] }}
                    </md-menu-item>
                </md-menu-content>
            </md-menu>
            <span class="md-error px-3 pb-2" v-if="errors && errors.length">
                {{ errors[0] }}
            </span>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        fieldClass: {
            type: Object,
            default: () => ({})
        },
        errors: {
            type: Array,
            default: () => []
        },
        name: {
            type: String,
            default: 'country_id'
        },
        disabled: {
            type: Boolean,
            default: false
        },
        countryId: {
            type: Number,
            default: null
        },
        label: String,
        newVersion: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            country_id: null,
            countries: false,
        };
    },
    computed: {
        currentLabel() {
            const list = Array.isArray(this.countries) ? this.countries : [];
            const found = list.find(c => c && c.id === this.country_id);
            if (!found) return '';
            const nom = found.nom || found.name;
            if (nom && typeof nom === 'object') {
                return nom[this.$i18n.locale()] || '';
            }
            return nom || '';
        }
    },
    watch: {
        countryId(newVal) {
            // keep internal value in sync if parent changes
            this.country_id = newVal;
        }
    },
    mounted() {
        if (this.countryId) {
            this.country_id = this.countryId;
        }

        this.initSource();
    },
    methods: {
        initSource() {
            axios.get('/api/countries').then((response) => {
                if (! this.country_id) {
                    this.country_id = 1;
                    this.selected(1);
                }

                this.countries = response.data.map((c) => {
                    return {
                        ...c,
                        name: c.nom,
                    };
                });
            });
        },
        choose(country) {
            if (country && typeof country.id !== 'undefined') {
                this.country_id = country.id;
                this.$emit('on-change', country.id);
                // also emit input for v-model compatibility
                this.$emit('input', country.id);
            }
        },
        selected(value) {
            // update internal value and notify parent
            this.country_id = value;
            this.$emit('on-change', value);
            this.$emit('input', value);
        }
    }
};
</script>
<style lang="scss">
.country-selector {
    .md-ripple {
        justify-content: flex-start;
        padding: 0;
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/CountrySelector.vue